import {
  Activity,
  Award,
  Bell,
  BellRing,
  Blocks,
  BookOpen,
  Building2,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  Camera,
  ChartColumn,
  ChartLine,
  Circle,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Copy,
  CreditCard,
  Database,
  ExternalLink,
  FileText,
  FolderCheck,
  FolderOpen,
  FolderTree,
  Gauge,
  GitCompareArrows,
  Hand,
  HandHeart,
  Headphones,
  Heart,
  HeartPulse,
  History,
  House,
  IdCard,
  Images,
  Inbox,
  KeyRound,
  Landmark,
  LayoutDashboard,
  List,
  ListChecks,
  MapPin,
  Megaphone,
  Menu,
  MessageSquareText,
  Monitor,
  MonitorPlay,
  Music,
  Network,
  NotebookPen,
  Package,
  PackageCheck,
  Phone,
  PhoneCall,
  Plug,
  PlugZap,
  Plus,
  QrCode,
  Radar,
  Radio,
  RadioTower,
  Receipt,
  RefreshCw,
  Repeat,
  ScrollText,
  Send,
  Settings,
  ShieldAlert,
  ShieldCheck,
  ShoppingBag,
  Siren,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Stamp,
  Store,
  Tags,
  Ticket,
  Truck,
  Upload,
  UserCog,
  UserPen,
  UserPlus,
  Users,
  Utensils,
  Vote,
  type LucideIcon,
} from 'lucide-react';

/** Pictogrammes des entrées de navigation (`icon` des module.json, noms lucide). */
const ICONS: Record<string, LucideIcon> = {
  activity: Activity,
  award: Award,
  bell: Bell,
  'bell-ring': BellRing,
  blocks: Blocks,
  'book-open': BookOpen,
  'building-2': Building2,
  'calendar-check': CalendarCheck,
  'calendar-clock': CalendarClock,
  'calendar-days': CalendarDays,
  'calendar-range': CalendarRange,
  camera: Camera,
  'chart-column': ChartColumn,
  'chart-line': ChartLine,
  'clipboard-check': ClipboardCheck,
  'clipboard-list': ClipboardList,
  clock: Clock,
  copy: Copy,
  'credit-card': CreditCard,
  database: Database,
  'external-link': ExternalLink,
  'file-text': FileText,
  'folder-check': FolderCheck,
  'folder-open': FolderOpen,
  'folder-tree': FolderTree,
  gauge: Gauge,
  'git-compare-arrows': GitCompareArrows,
  hand: Hand,
  'hand-heart': HandHeart,
  headphones: Headphones,
  heart: Heart,
  'heart-pulse': HeartPulse,
  history: History,
  house: House,
  'id-card': IdCard,
  images: Images,
  inbox: Inbox,
  'key-round': KeyRound,
  landmark: Landmark,
  'layout-dashboard': LayoutDashboard,
  list: List,
  'list-checks': ListChecks,
  'map-pin': MapPin,
  megaphone: Megaphone,
  menu: Menu,
  'message-square-text': MessageSquareText,
  monitor: Monitor,
  'monitor-play': MonitorPlay,
  music: Music,
  network: Network,
  'notebook-pen': NotebookPen,
  package: Package,
  'package-check': PackageCheck,
  phone: Phone,
  'phone-call': PhoneCall,
  plug: Plug,
  'plug-zap': PlugZap,
  plus: Plus,
  'qr-code': QrCode,
  radar: Radar,
  radio: Radio,
  'radio-tower': RadioTower,
  receipt: Receipt,
  'refresh-cw': RefreshCw,
  repeat: Repeat,
  'scroll-text': ScrollText,
  send: Send,
  settings: Settings,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  'shopping-bag': ShoppingBag,
  siren: Siren,
  'sliders-horizontal': SlidersHorizontal,
  smartphone: Smartphone,
  sparkles: Sparkles,
  stamp: Stamp,
  store: Store,
  tags: Tags,
  ticket: Ticket,
  truck: Truck,
  upload: Upload,
  'user-cog': UserCog,
  'user-pen': UserPen,
  'user-plus': UserPlus,
  users: Users,
  utensils: Utensils,
  vote: Vote,
};

export function iconOf(name: string | undefined): LucideIcon {
  return (name === undefined ? undefined : ICONS[name]) ?? Circle;
}

/** Noms connus (contrôle des module.json par le test de la navigation). */
export const ICON_NAMES = Object.keys(ICONS);
